<template>
<transition name='fast-fade'>
  <div
    v-if='ready'
    id='slide-journal_overlay'
    class="slide-journal_overlay"
  >
    <JournalApp
      :activity='activity'
      :slide_result='slide_result'
      :api_client='api_client'
      :updateResult='updateResult'
    >
      <a
        href="#"
        class='slide-journal_next button-one-branded'
        @click.prevent='skip'
      >
        {{ $t('keep_learning') }}
      </a>
    </JournalApp>
  </div>
</transition>
</template>

<script>
import JournalApp from './journal-v1-app'

export default {
  props: [
    'slide_result',
    'activity',
    'api_client',
    'toggle',
    'goToNextSlide',
    'updateResult'
  ],

  data() {
    return {
      ready: false
    }
  },

  created() {
    this.ready = true
  },

  components: {
    JournalApp
  },

  methods: {
    skip() {
      this.goToNextSlide()
      this.toggleOverlay()
    },

    toggleOverlay() {
      this.toggle()
    }
  }

}
</script>
